import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cfg = { withCredentials: true };

export const STATUS_META = {
  in_use: { label: '使用中', cls: 'bg-blue-50 text-blue-700 border-blue-200' },
  storage: { label: '保管', cls: 'bg-zinc-100 text-zinc-600 border-zinc-200' },
  repair: { label: '修理中', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
  disposed: { label: '廃棄', cls: 'bg-rose-50 text-rose-600 border-rose-200' },
};

export const KIND_META = {
  equipment: { label: '備品' },
  consumable: { label: '消耗品' },
};

export const bihinApi = {
  access: () => axios.get(`${API}/bihin/access`, cfg).then((r) => r.data),
  dashboard: () => axios.get(`${API}/bihin/dashboard`, cfg).then((r) => r.data),
  items: (params) => axios.get(`${API}/bihin/items`, { ...cfg, params }).then((r) => r.data),
  item: (id) => axios.get(`${API}/bihin/items/${id}`, cfg).then((r) => r.data),
  createItem: (body) => axios.post(`${API}/bihin/items`, body, cfg).then((r) => r.data),
  // D. 共通採番（EQP/CSM）の次番号を覗く（カウンターは進めない）
  nextSharedNo: (prefix) => axios.get(`${API}/bihin/items/next-shared-no`, { params: { prefix }, ...cfg }).then((r) => r.data),
  updateItem: (id, body) => axios.put(`${API}/bihin/items/${id}`, body, cfg).then((r) => r.data),
  deleteItem: (id) => axios.delete(`${API}/bihin/items/${id}`, cfg).then((r) => r.data),
  upload: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return axios.post(`${API}/bihin/upload`, fd, cfg).then((r) => r.data);
  },
  loan: (itemId, body) => axios.post(`${API}/bihin/items/${itemId}/loan`, body, cfg).then((r) => r.data),
  returnLoan: (loanId, body = {}) => axios.post(`${API}/bihin/loans/${loanId}/return`, body, cfg).then((r) => r.data),
  loans: (params) => axios.get(`${API}/bihin/loans`, { ...cfg, params }).then((r) => r.data),
  adjustStock: (itemId, body) => axios.post(`${API}/bihin/items/${itemId}/stock`, body, cfg).then((r) => r.data),
  floormaps: () => axios.get(`${API}/bihin/floormaps`, cfg).then((r) => r.data),
  createFloormap: (name, file) => {
    const fd = new FormData();
    fd.append('name', name);
    fd.append('file', file);
    return axios.post(`${API}/bihin/floormaps`, fd, cfg).then((r) => r.data);
  },
  deleteFloormap: (id) => axios.delete(`${API}/bihin/floormaps/${id}`, cfg).then((r) => r.data),
  setPin: (itemId, body) => axios.put(`${API}/bihin/items/${itemId}/pin`, body, cfg).then((r) => r.data),
  departments: () => axios.get(`${API}/departments`, cfg).then((r) => r.data),
};

export const fileUrl = (path) => (path ? `${process.env.REACT_APP_BACKEND_URL}${path}` : null);
